import * as React from "react";
import { useState, useCallback } from "react";
import PaginatedItemOverview from "components/common/PaginatedItemOverview";
import SectionComponent from "components/common/Section/SectionComponent";
import RolesQueryHelp from "components/users/RolesQueryHelp";
import TeamsDomain from "../../domainActions/TeamsDomain";
const RolesSection = ({ team: { id, name } }) => {
  const [loading, setLoading] = useState(false);
  const _onLoad = useCallback(
    (pagination, isSubscribed) => {
      setLoading(true);
      return TeamsDomain.loadRolesForTeam(id, name, pagination).then((paginatedRoles) => {
        if (isSubscribed) {
          setLoading(false);
        }
        return paginatedRoles;
      });
    },
    [id, name]
  );
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: "Roles", showLoading: loading }, /* @__PURE__ */ React.createElement(
    PaginatedItemOverview,
    {
      noDataText: "No selected roles have been found.",
      onLoad: _onLoad,
      queryHelper: /* @__PURE__ */ React.createElement(RolesQueryHelp, null)
    }
  ));
};
export default RolesSection;
